import { BaseListenable1u3g4s45l82o6 as BaseListenable } from './abstracts.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  KtSetjrjc7fhfd6b9 as KtSet,
  KtMutableSetwuwn7k5m570a as KtMutableSet,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  valueSet3cf2hvvu95f3 as valueSet,
  set3ct43wkzm94lj as set,
  lens2e2i845xidu26 as lens,
  lens26es9640ifscs as lens_0,
  get_state389x218zizu8a as get_state,
  MutableReactiveValuettf5l2qj6mxh as MutableReactiveValue,
} from './coreInterfaces.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ReactiveMutableSetClass;
function ReactiveMutableSet() {
  if (ReactiveMutableSetClass === VOID) {
    class $ extends BaseListenable() {
      constructor(hashSet) {
        return new.target.new_com_lightningkite_reactive_core_ReactiveMutableSet_oy7nqq_k$(hashSet);
      }
      static new_com_lightningkite_reactive_core_ReactiveMutableSet_oy7nqq_k$(hashSet) {
        var $this = this.new_com_lightningkite_reactive_core_BaseListenable_e3suws_k$();
        $this.hashSet_1 = hashSet;
        return $this;
      }
      static new_com_lightningkite_reactive_core_ReactiveMutableSet_72mh0y_k$() {
        return this.new_com_lightningkite_reactive_core_ReactiveMutableSet_oy7nqq_k$(LinkedHashSet().new_kotlin_collections_LinkedHashSet_ahyf7j_k$());
      }
      set_value_sfp2ke_k$(value) {
        if (!this.hashSet_1.equals(value)) {
          this.hashSet_1.clear_j9egeb_k$();
          this.addAll_v4mac1_k$(value);
        }
      }
      set_value_v1vabv_k$(_set____db54di) {
        return this.set_value_sfp2ke_k$((!(_set____db54di == null) ? isInterface(_set____db54di, KtSet()) : false) ? _set____db54di : THROW_CCE());
      }
      get_value_j01efc_k$() {
        return this.hashSet_1;
      }
      addAll_v4mac1_k$(elements) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableSet.signal' call
        // Inline function 'kotlin.also' call
        var this_0 = this.hashSet_1.addAll_4lah1e_k$(elements);
        if (this_0) {
          this.invokeAllListeners_uusj2y_k$();
        }
        return this_0;
      }
      addAll_4lah1e_k$(elements) {
        return this.addAll_v4mac1_k$(elements);
      }
      add_wl2rvy_k$(element) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableSet.signal' call
        // Inline function 'kotlin.also' call
        var this_0 = this.hashSet_1.add_utx5q5_k$(element);
        if (this_0) {
          this.invokeAllListeners_uusj2y_k$();
        }
        return this_0;
      }
      add_utx5q5_k$(element) {
        return this.add_wl2rvy_k$(element);
      }
      remove_an8aut_k$(element) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableSet.signal' call
        // Inline function 'kotlin.also' call
        var this_0 = this.hashSet_1.remove_cedx0m_k$(element);
        if (this_0) {
          this.invokeAllListeners_uusj2y_k$();
        }
        return this_0;
      }
      remove_cedx0m_k$(element) {
        if (!true)
          return false;
        return this.remove_an8aut_k$(element);
      }
      iterator_jk1svi_k$() {
        return this.hashSet_1.iterator_jk1svi_k$();
      }
      isEmpty_y1axqb_k$() {
        return this.hashSet_1.isEmpty_y1axqb_k$();
      }
      contains_ccp5tc_k$(element) {
        return this.hashSet_1.contains_aljjnj_k$(element);
      }
      contains_aljjnj_k$(element) {
        if (!true)
          return false;
        return this.contains_ccp5tc_k$(element);
      }
      containsAll_70sc4t_k$(elements) {
        return this.hashSet_1.containsAll_xk45fg_k$(elements);
      }
      containsAll_xk45fg_k$(elements) {
        return this.containsAll_70sc4t_k$(elements);
      }
      get_size_woubt6_k$() {
        return this.hashSet_1.get_size_woubt6_k$();
      }
    }
    protoOf($).valueSet_aujvv6_k$ = valueSet;
    protoOf($).set_revjhg_k$ = set;
    protoOf($).lens_drj4fu_k$ = lens;
    protoOf($).lens_u4wb4z_k$ = lens_0;
    protoOf($).get_state_wc71uu_k$ = get_state;
    initMetadataForClass($, 'ReactiveMutableSet', $.new_com_lightningkite_reactive_core_ReactiveMutableSet_72mh0y_k$, VOID, [KtMutableSet(), MutableReactiveValue()], [1]);
    ReactiveMutableSetClass = $;
  }
  return ReactiveMutableSetClass;
}
//region block: exports
export {
  ReactiveMutableSet as ReactiveMutableSet2bktc9g3zyrtk,
};
//endregion

//# sourceMappingURL=ReactiveMutableSet.mjs.map
